/* ============================================================
   SKRATCH LABS ZA — theme.js
   Header interactions, search, mobile menu, carousels
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE MENU ──────────────────────────────────────────
  const hamburger = document.querySelector('.sl-hamburger');
  const mobileMenu = document.getElementById('sl-mobile-menu');
  const mobileClose = document.querySelector('.sl-mobile-menu__close');
  const mobileOverlay = document.querySelector('.sl-mobile-menu__overlay');

  function openMobileMenu() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Mobile accordions
  document.querySelectorAll('.sl-mobile-menu__accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = content.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.sl-mobile-menu__accordion-content').forEach(function (c) {
        c.classList.remove('is-open');
      });
      document.querySelectorAll('.sl-mobile-menu__accordion-btn').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        content.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── SEARCH OVERLAY ───────────────────────────────────────
  const searchToggle = document.querySelector('.sl-search-toggle');
  const searchOverlay = document.getElementById('sl-search-overlay');
  const searchClose = document.querySelector('.sl-search-overlay__close');
  const searchInput = document.querySelector('.sl-search-overlay__input');

  function openSearch() {
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileMenu();
    }
  });

  // ── FIND YOUR FUEL CAROUSEL ───────────────────────────────
  const fuelCarousel = document.getElementById('sl-fuel-carousel');
  const fuelPrev = document.querySelector('.sl-fuel__arrow--prev');
  const fuelNext = document.querySelector('.sl-fuel__arrow--next');

  if (fuelCarousel) {
    const cardWidth = 260 + 0; // width + gap
    const scrollAmt = cardWidth * 2;

    if (fuelPrev) fuelPrev.addEventListener('click', function () {
      fuelCarousel.scrollBy({ left: -scrollAmt, behavior: 'smooth' });
    });
    if (fuelNext) fuelNext.addEventListener('click', function () {
      fuelCarousel.scrollBy({ left: scrollAmt, behavior: 'smooth' });
    });

    // Active card highlight on scroll
    function updateActiveCard() {
      const cards = fuelCarousel.querySelectorAll('.sl-fuel__card');
      const center = fuelCarousel.scrollLeft + fuelCarousel.offsetWidth / 2;
      let closest = null;
      let minDist = Infinity;
      cards.forEach(function (card) {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(cardCenter - center);
        if (dist < minDist) { minDist = dist; closest = card; }
      });
      cards.forEach(function (c) { c.classList.remove('is-active'); });
      if (closest) closest.classList.add('is-active');
    }

    fuelCarousel.addEventListener('scroll', updateActiveCard, { passive: true });
    updateActiveCard();
  }

  // ── BEST SELLERS CAROUSEL ─────────────────────────────────
  const bsCarousel = document.getElementById('sl-bestsellers-carousel');
  const bsPrev = document.querySelector('.sl-bestsellers__arrow--prev');
  const bsNext = document.querySelector('.sl-bestsellers__arrow--next');

  if (bsCarousel) {
    const bsScrollAmt = 300;
    if (bsPrev) bsPrev.addEventListener('click', function () {
      bsCarousel.scrollBy({ left: -bsScrollAmt, behavior: 'smooth' });
    });
    if (bsNext) bsNext.addEventListener('click', function () {
      bsCarousel.scrollBy({ left: bsScrollAmt, behavior: 'smooth' });
    });
  }

  // ── SCROLL REVEAL ANIMATION ───────────────────────────────
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll('.sl-fuel__card, .sl-bs-card, .sl-pdp-card');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  // ── HEADER SCROLL SHADOW ──────────────────────────────────
  const header = document.getElementById('sl-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 16px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = '';
      }
    }, { passive: true });
  }

  // ── PDP ACCORDIONS ────────────────────────────────────────
  document.querySelectorAll('.sl-pdp-accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = content.classList.contains('is-open');
      this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      content.classList.toggle('is-open', !isOpen);
    });
  });

});
